module.exports = __webpack_public_path__ + "img/bsn_1.fb4c5f2f.png";